import type { PageData } from '../../../../_metronic/helpers/utils/types';
import { getIdealImageSize } from '../../../../_metronic/helpers/utils/utils';

export const backgroundData: PageData = [
  {
    formId: 'form1',
    heading: 'Background Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'title', label: 'Title', type: 'input' },
      { id: 'subtitle', label: 'Subtitle', type: 'input' }
    ]
  }
];

export const formData: PageData = [
  {
    formId: 'form1',
    heading: 'Form Section',
    data: [
      { id: 'title', label: 'Form Title', type: 'input' },
      { id: 'subtitle', label: 'Contact Title', type: 'input' },
      {
        id: 'image',
        label: 'Background Image (in contact)',
        info: getIdealImageSize(414.614, 385.234),
        backgroundColor: 'black',
        type: 'image'
      },
      { id: 'address', label: 'Address', type: 'textarea' },
      {
        id: 'icon',
        label: 'Map Icon',
        info: getIdealImageSize(31.2, 39),
        type: 'image',
        backgroundColor: 'black'
      },
      { id: 'inputLabel1', label: 'Input 1 label', type: 'input' },
      { id: 'inputPlaceholder1', label: 'Input 1 placeholder', type: 'input' },
      { id: 'inputLabel2', label: 'Input 2 label', type: 'input' },
      { id: 'inputPlaceholder2', label: 'Input 2 placeholder', type: 'input' },
      { id: 'inputLabel3', label: 'Input 3 label', type: 'input' },
      { id: 'inputPlaceholder3', label: 'Input 3 placeholder', type: 'input' },
      { id: 'inputLabel4', label: 'Input 4 label', type: 'input' },
      { id: 'inputPlaceholder4', label: 'Input 4 placeholder', type: 'input' },
      { id: 'selectLabel', label: 'Select label', type: 'input' },
      { id: 'textareaLabel', label: 'Textarea label', type: 'input' },
      { id: 'textareaPlaceholder', label: 'Textarea placeholder', type: 'input' },
      { id: 'buttonText', label: 'Button text', type: 'input' }
    ]
  },
  {
    formId: 'formGroup1',
    heading: 'Select Options',
    data: [{ id: 'option', label: 'Option name', type: 'input' }]
  },
  {
    formId: 'formGroup2',
    heading: 'Contact Information',
    data: [
      {
        id: 'icon1',
        label: 'Contact icon',
        info: getIdealImageSize(24, 24),
        type: 'image',
        backgroundColor: 'black'
      },
      { id: 'info', label: 'Contact info', type: 'input' }
    ]
  },
  {
    formId: 'formGroup3',
    heading: 'Social Media Information',
    data: [
      {
        id: 'icon2',
        label: 'Social Media icon',
        info: getIdealImageSize(19, 19),
        type: 'image',
        backgroundColor: 'black'
      },
      { id: 'link', label: 'Social Media link', type: 'input' }
    ]
  }
];
